<tr
  class="flex p-2 well-level-row hover:bg-[var(--p-content-hover-background)]"
  [ngClass]="{
    'name': treeNode?.node.data.level === designLevel,
    'level-company': treeNode?.node.data.level === 'companies',
    'level-project': treeNode?.node.data.level === 'projects',
    'level-site': treeNode?.node.data.level === 'sites',
    'level-well': treeNode?.node.data.level === 'wells',
    'level-wellbore': treeNode?.node.data.level === 'wellbores',
    'level-design': treeNode?.node.data.level === designLevel
  }"
  [ttRow]="treeNode"
  [ttSelectableRowDblClick]="treeNode"
  (contextmenu)="filterContextMenu(treeNode.node.data.level)"
  (mouseenter)="onMouseOver(treeNode)"
  (mouseleave)="onMouseLeave()"
>
  @for (col of columns; track col; let i = $index) {
  <td
    [ngClass]="{ 'name': treeNode.node.data.level === designLevel }"
    class="w-full"
  >
    <div class="row-content flex items-center">
      @if (i === 0 && treeNode.node.data.level !== designLevel) {
        <p-treeTableToggler
          [ngClass]="{ 'name': treeNode.node.data.level === designLevel }"
          [rowNode]="getReducedIndentRowNode(treeNode)"
          class="pr-1"
        ></p-treeTableToggler>
      }
      <!-- @if (treeNode.node.data.level !== designLevel) {
        <img 
          class="level-icon" 
          [src]="treeNode.node.data.icon" 
        />
      } -->
      @if (treeNode.node.data.level !== designLevel) {
        <span
          class="level-pill"
          [ngClass]="getLevelPillClass(treeNode.node.data.level)">
          {{ getWellExplorerLevelName(treeNode.node.data.level) }}
        </span>
      }
      <span 
        class="pl-2 text-xs flex-1 min-w-0"
        [ngClass]="{ 'might-overflow-design': treeNode.node.data.level === designLevel, 'might-overflow': treeNode.node.data.level !== designLevel }" 
      >
        {{ rowData[col.field] }}
      </span>
      </div>
  </td>
  }

  <td class="action-cell">
      <div class="flex gap-2 action-icons" [ngClass]="{ 'is-visible': hover && hoverNode === treeNode }">
      <span class="flex items-center gap-2">
        <!-- Add Button -->
          @if (treeNode.node.data.level !== designLevel) {
            <i
              class="pi pi-plus cursor-pointer !text-green-400"
              pTooltip="{{ 'Create New ' + getChildLevel(treeNode.node.data.level)?.slice(0, -1) | titlecase }}"
              (click)="addChildNode(treeNode.node)"
            ></i>
          }

          <!-- Clone Button -->
          @if (treeNode.node.data.level === designLevel) {
            <i
              class="pi pi-copy cursor-pointer !text-blue-400"
              pTooltip="Clone"
              (click)="cloneDesign(treeNode.node)"
            ></i>
          }

          <!-- Delete Button -->
          @if (isAdmin || isGlobalAdmin) {
            <i
              class="pi pi-trash cursor-pointer !text-red-400"
              pTooltip="Delete"
              (click)="deleteItem(treeNode.node)"
            ></i>
          }

          <!-- Lock Icon -->
          @if (!isAdmin && !isGlobalAdmin) {
            <i
              class="pi pi-lock text-gray-400 cursor-not-allowed"
              pTooltip="Only Admin level users have permissions to delete Well Explorer items"
            ></i>
          }
      </span>
      </div>
  </td>
</tr>
